import React, { useState, useContext, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";

import ContextComponent from "../../../AppContext";
import Utils from "../../../Utils";
import DataTable from "../../../controls/table/DataTable";
import AddIcon from "../../../../assets/img/add.png";
import EditIcon from "../../../../assets/img/Edit.png";
import ResetPasswordIcon from "../../../../assets/img/settings.png";
import DeleteIcon from "../../../../assets/img/Delete.png";
import defaultUserImage from "../../../../assets/img/default-profile.png";
import AddUserPage from "./AddUserPage";
import EditUserPage from "./EditUserPage";
import EmptyPage from "./../../../pages/EmptyPage";

const Userpage = () => {

    let [showDeleteModal, setShowDeleteModal] = useState(false);
    let [selectedItemCount, setSelectedItemCount] = useState(0);

    const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;
    let [editIconClass, setEditIconClass] = useState(DISABLED_ICON);
    let [resetPasswordIconClass, setResetPasswordIconClass] =
        useState(DISABLED_ICON);

    let [tableSelectedItems, setTableSelectedItems] = useState([]);
    let [userIdForEdit, setUserIdForEdit] = useState("");
    let [usersForResetPassword, setUsersForResetPassword] = useState([]);
    let [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
    let [allUsers, setAllUsers] = useState([]);

    useEffect(() => {
        if (tableSelectedItems.length === 1) {
            setEditIconClass("");
            setUserIdForEdit(tableSelectedItems[0]);
        } else {
            setEditIconClass(DISABLED_ICON);
            setUserIdForEdit("");
        }
        if (tableSelectedItems.length > 0) {
            setResetPasswordIconClass("");
            setUsersForResetPassword(tableSelectedItems);
            let tempUsers = [];
            allUsers.forEach((user) => {
                tableSelectedItems.indexOf(user.id) > -1 && tempUsers.push(user);
            });
            setUsersForResetPassword(tempUsers);
        } else {
            setResetPasswordIconClass(DISABLED_ICON);
            setUsersForResetPassword([]);
        }
    }, [tableSelectedItems]);

    let [editModalCanOpen, setEditModalCanOpen] = useState(false);
    let [editableUser, setEditableUser] = useState({});
    let [editableUserIndex, setEditableUserIndex] = useState(-1);

    const openEditModal = (e) => {
        e.preventDefault();
        setEditModalCanOpen(true);
        let targetUser = {};
        allUsers.forEach((user, index) => {
            if (user.id === userIdForEdit) {
                targetUser = user;
                setEditableUserIndex(index);
            }
        });
        //console.log(targetUser);
        !Utils.isObjectEmpty(targetUser) && setEditableUser(targetUser);
    };

    let { setCanRedirectToLogin, setLoadingState, setAlert } =
        useContext(ContextComponent);

    let [tableColumns, setTableColumns] = useState([
        "id",
        "select",
        // "salutation",
        "firstname",
        "lastname",
        // "pronoun",
        // "region",
        "email",
        // "department",
        // "brand",
        // "title",
        "sites",
        "projects",
        "roles",
        "admin",
    ]);

    let [tableColumnSchema, setTableColumnSchema] = useState({
        id: {
            type: "hidden",
            title: "id",
        },
        select: {
            type: "checkbox",
            title: "-",
        },
        firstname: {
            type: "text",
            search: true,
            sort: true,
            title: "First Name",
        },
        lastname: {
            type: "text",
            search: true,
            sort: true,
            title: "Last Name",
        },
        email: {
            type: "text",
            search: true,
            title: "Email",
        },
        sites: {
            type: "text",
            title: "Sites",
        },
        projects: {
          type: "text",
          title: "Projects",
        },
        roles: {
            type: "text",
            title: "Roles",
        },
        admin: {
            type: "boolean",
            title: "admin",
            disabled: true,
            center: true,
        },
    });

    let [tableData, setTableData] = useState([]);
    let [canRender, setCanRender] = useState(false);
    let [renderDataTable, setRenderDataTable] = useState(false);
    let [renderEmptyPage, setRenderEmptyPage] = useState(false);
    let [updateTable, setUpdateTable] = useState(false);

    const findPathById = (data, targetId) => {
      for (const node of data) {
        if (node.id === targetId) return node.path;
  
        if (node.children?.length) {
          const result = findPathById(node.children, targetId);
          if (result) return result;
        }
      }
      return null;
    };
  
    const getProjectPathFromIds = (data, idArray) => {
      let result = idArray
        .map((id) => findPathById(data, id))
        .filter(Boolean)
        .map((path) => (path.startsWith("/") ? path.slice(1) : path))
        .join(", ");
      return result;
    };

    const updateTableData = (data, folderData) => {
        setAllUsers(data);
        let userInfo = data;
        let usersArray = [];
        if (!Utils.isObjectEmpty(userInfo)) {
            usersArray = userInfo.map((user, index) => {
                let userTableObj = [];
                let userTableData = [];
                tableColumns.forEach((col) => {
                    if (col === "select") {
                        userTableData.push(false);
                    } else if (col === "admin") {
                        let isSuperAdmin = userInfo[index]['superAdmin'];
                        let valueToBePush = isSuperAdmin ? Utils.APP_CONSTANTS.DOUBLE_TICK : userInfo[index][col];
                        userTableData.push(valueToBePush);
                    } else if (col === "username") {
                        userTableData.push(
                            userInfo[index].firstname + " " + userInfo[index].lastname
                        );
                    } else if (col === "roles") {
                        userTableData.push(userInfo[index].roles.join(", "));
                    } else if (col === "sites") {
                        userTableData.push(userInfo[index].sites.join(", "));
                    } else if (col === "projects") {
                      userTableData.push(
                         getProjectPathFromIds(folderData, userInfo[index]?.projects)
                      );
                    } else {
                        userTableData.push(userInfo[index][col]);
                    }
                });
                userTableObj = userTableData;
                return userTableObj;
            });

            setTableData(usersArray);
            setCanRender(true);
        }
    };

    const folderSuccess = (userData, folderData) => {
      updateTableData(userData, folderData);
  
      setRenderDataTable(userData.length !== 0);
      setRenderEmptyPage(userData.length === 0);
    };
  
    const success = (res) => {
      setLoadingState({
        applyMask: false,
      });
  
      Utils.getAllFolders().then(
        (response) => folderSuccess(res.data, response.data),
        fail
      );
    };

    const fail = (err) => {
        setLoadingState({
            applyMask: false,
        });
        err?.message?.length && console.log(err);
        if (err?.redirect) {
            setCanRedirectToLogin(true);
        }
    };

    const loadAllUsers = () => {
        Utils.getAllUsers().then(success, fail);
    };

    useEffect(() => {
        setLoadingState({
            applyMask: true,
            text: "Loading users",
        });
        loadAllUsers();
    }, []);

    const handleShow = async (e) => {
        if (tableSelectedItems?.length > 0) {
            await setSelectedItemCount(tableSelectedItems?.length);
            setShowDeleteModal(true);
        }
    };

    const handleResetPasswordShow = async (e) => {
        if (tableSelectedItems?.length > 0) {
            await setSelectedItemCount(tableSelectedItems?.length);
            setShowResetPasswordModal(true);
        }
    };

    const handleResetPasswordClose = async (e) => {
        await setSelectedItemCount(tableSelectedItems?.length);
        setShowResetPasswordModal(false);
    };

    const handleClose = async (e) => {
        await setSelectedItemCount(tableSelectedItems?.length);
        setShowDeleteModal(false);
    };

    const deleteSuccess = (res) => {
        setAlert({
            show: true,
            message: "User(s) deleted successfully",
        });
        setTableSelectedItems([]);
        setUpdateTable(!updateTable);
    };

    const deleteFail = (err) => {
        err?.message?.length && console.log(err);
        if (err?.redirect) {
            setCanRedirectToLogin(true);
        }
        setAlert({
            show: true,
            message: err?.data?.message
                ? err.data.message
                : "User(s) deletion failed",
            type: "danger",
        });
    };

    const handleDelete = async (e) => {
        //debugger;
        setShowDeleteModal(false);
        // setLoadingState({
        //   applyMask: true,
        //   text: "Deleting selected " + tableSelectedItems.length + " items",
        // });
        let tempTableData = tableData.filter((d) => {
            return tableSelectedItems.indexOf(d[0]) === -1;
        });
        setTableData(tempTableData);
        Utils.deleteUsers(tableSelectedItems).then(deleteSuccess, deleteFail);
    };

    const resetPasswordSuccess = (res) => {
        setLoadingState({
            applyMask: false
        });
        setAlert({
            show: true,
            message: "Resetting password successfully done!",
        });
    };

    const resetPasswordFail = (err) => {
        err?.message?.length && console.log(err);
        setLoadingState({
            applyMask: false
        });
        if (err?.redirect) {
            setCanRedirectToLogin(true);
        }
        setAlert({
            show: true,
            message: err?.data?.message
                ? err.data.message
                : "Reset password(s) failed",
            type: "danger",
        });
    };

    const handleResetPassword = async (e) => {
        setShowResetPasswordModal(false);
        setLoadingState({
            applyMask: true,
            text: "Resetting passwords",
        });
        Utils.resetPasswordUsers(tableSelectedItems).then(
            resetPasswordSuccess,
            resetPasswordFail
        );
    };



    let [addModalCanOpen, setAddModalCanOpen] = useState(false);


    const openAddModal = (e) => {
        e.preventDefault();
        setAddModalCanOpen(true);
    };

    const closeAddModal = (e) => {
        setAddModalCanOpen(false);
    };

    return (
        <div className="indi-body-cards-wrapper d-flex w-100">
            <div className="indi-add-card-title">
                Users
                <div className="d-none1 w-50 indi-body-actions">
                    <div className="indi-body-action">
                        {/* <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img> */}
                        {/* <FloatingLabel label="">
                            <Form.Select
                                defaultValue="clear"
                                id="region"
                                size="sm"
                                className="indi-input-field indi-input-select-field indi-users-table-region-dropdown"
                                onChange={regionHandler}
                            >
                                <option value="clear">All</option>
                                {sortedRegions.map((keyName, index) => (
                                    <option value={keyName} key={index}>
                                        {REGIONS[keyName]}
                                    </option>
                                ))}
                            </Form.Select>
                        </FloatingLabel> */}
                    </div>
                    {/* <div
                        className="indi-body-action"
                        role="button"
                    // onClick={openBulkUploadModal}
                    >
                        <img
                            className="indi-w-24 indi-bulk-upload-img"
                            src={BulkUploadIcon}
                            alt="Bulk-upload-icon"
                        ></img>
                        Bulk upload
                    </div> */}
                    <div
                        className="indi-body-action"
                        role="button"
                        onClick={openAddModal}
                    >
                        <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
                        Add
                    </div>

                    <div
                        className={`indi-body-action ${editIconClass}`}
                        role="button"
                        onClick={openEditModal}
                    >
                        <img className="indi-w-20" src={EditIcon} alt="edit-icon"></img>
                        Edit
                    </div>

                    <div className="indi-body-action" role="button" onClick={handleShow}>
                        <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img>
                        Delete
                    </div>

                    {/* <div
                        className={`indi-body-action ${resetPasswordIconClass}`}
                        role="button"
                        onClick={handleResetPasswordShow}
                    >
                        <img
                            className="indi-w-20"
                            src={ResetPasswordIcon}
                            alt="Reset-password-icon"
                        ></img>
                        Reset password
                    </div> */}
                </div>
            </div>
            {canRender && (
                <>
                    {renderDataTable && (
                        <DataTable
                            minRows={0}
                            tableProps={{
                                tableColumns,
                                tableColumnSchema,
                                tableData,
                                tableSelectedItems,
                                setTableSelectedItems,
                            }}
                        />
                    )}
                    {!renderDataTable && (
                        <EmptyPage
                            props={{
                                emptyMessage: "No users are available",
                            }}
                        />
                    )}
                </>
            )}

            <Modal centered show={showDeleteModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete confirmation?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure to delete select {selectedItemCount} user(s)?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        No
                    </Button>
                    <Button variant="primary" onClick={handleDelete}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {addModalCanOpen && (
                <AddUserPage
                    props={{
                        addModalCanOpen,
                        setAddModalCanOpen,
                        tableData,
                        setTableData,
                        loadAllUsers,
                    }}
                />
            )}

            {editModalCanOpen && (
                <EditUserPage
                    props={{
                        editModalCanOpen,
                        setEditModalCanOpen,
                        tableData,
                        setTableData,
                        editableUser,
                        editableUserIndex,
                        allUsers,
                        setAllUsers,
                        loadAllUsers,
                    }}
                />
            )}

            <Modal
                centered
                show={showResetPasswordModal}
                onHide={handleResetPasswordClose}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Are you sure to reset the below user(s)?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {usersForResetPassword.map((user, index) => (
                            <div key={index}>
                                <img
                                    className="indi-header-profile-image"
                                    src={
                                        user?.profileImage?.length > 0
                                            ? user?.profileImage
                                            : defaultUserImage
                                    }
                                    alt={user.firstname}
                                    title={user.firstname}
                                />
                                <span className="indi-reset-user-password-list-item">{user.firstname} {user.lastname}</span>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleResetPasswordClose}>
                        No
                    </Button>
                    <Button variant="primary" onClick={handleResetPassword}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* {bulkUploadModalCanOpen && (
                <UsersBulkUpload
                    props={{
                        addModalCanOpen: bulkUploadModalCanOpen,
                        setAddModalCanOpen: setBulkUploadModalCanOpen,
                        tableData,
                        setTableData,
                        success,
                    }}
                />
            )} */}
        </div>
    );
};

export default Userpage;